<template>
  <div
    v-if="isLoading"
    class="loading-overlay d-flex justify-content-center align-items-center"
  >
    <div class="spinner-border text-light" role="status">
      <span class="visually-hidden" />
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useStore } from "vuex";

const store = useStore();
const isLoading = computed(() => store.getters["app/isLoading"]);
</script>

<style scoped>
.loading-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2000;
}
</style>
